import { NgModule } from "@angular/core";

import { InputCheckboxModule } from "./checkbox/checkbox.module";
import { InputDateModule } from "./date/date.module";
import { DatesModule } from "./dates";
import { InputEmailModule } from "./email/email.module";
import { InputsModule } from "./inputs";
import { ListsModule } from "./lists";
import { InputMonthModule } from "./month/month.module";
import { InputOptionGroupModule } from "./option-group/option-group.module";
import { InputOptionModule } from "./option/option.module";
import { OptionsModule } from "./options";
import { InputSelectModule } from "./select/select.module";
import { InputSwitchModule } from "./switch/switch.module";
import { InputTelModule } from "./tel/tel.module";
import { InputTextModule } from "./text/text.module";
import { InputTextareaModule } from "./textarea/textarea.module";
import { InputWeekModule } from "./week/week.module";
import { InputYearModule } from "./year/year.module";

/**
 * The `InputModule` contains all input components.
 *
 * @deprecated – This module is deprecated. Please import each respective module for the input that you are using. This will improve the bundle size for your component.
 */
@NgModule({
  imports: [
    InputCheckboxModule,
    InputDateModule,
    InputEmailModule,
    InputMonthModule,
    InputOptionModule,
    InputOptionGroupModule,
    InputSelectModule,
    InputSwitchModule,
    InputTelModule,
    InputTextModule,
    InputTextareaModule,
    InputWeekModule,
    InputYearModule,
    // TODO(stefan): Not sure why these modules needs to be imported for it to build but here they are
    DatesModule,
    InputsModule,
    ListsModule,
    OptionsModule,
  ],
  exports: [
    InputCheckboxModule,
    InputDateModule,
    InputEmailModule,
    InputMonthModule,
    InputOptionModule,
    InputOptionGroupModule,
    InputSelectModule,
    InputSwitchModule,
    InputTelModule,
    InputTextModule,
    InputTextareaModule,
    InputWeekModule,
    InputYearModule,
    // TODO(stefan): Not sure why these modules needs to be imported for it to build but here they are
    DatesModule,
    InputsModule,
    ListsModule,
    OptionsModule,
  ],
})
export class InputModule {}
